import axiosInstance from "../utils/axiosInstance";

const getAttachments = (url, zahtjevId) =>
  axiosInstance
    .get(`${url}/${zahtjevId}?vrstaDokumenta=1`)
    .then(response => response);

export default getAttachments;
